import React from 'react';
import styled from "styled-components";

const SGrammarIndicativo = styled.div`
  flex: 1;
  padding: 5px 20px;
  td { padding: 5px; }
`;

const GrammarIndicativo = () => {
  return (
    <SGrammarIndicativo>
<h5>Modo Indicativo - Tryb oznajmujący</h5>

<p>
<li><a href="#pre">Presente</a></li>
<li><a href="#ppe">Pretérito Perfecto</a></li>
<li><a href="#pin">Pretérito Indefinido</a></li>
<li><a href="#fim">Futuro Imperfecto</a></li>
<li><a href="#pim">Pretérito Imperfecto</a></li>
<li><a href="#ppl">Pretérito Pluscuamperfecto</a></li>
<li><a href="#fpe">Futuro Perfecto</a></li>
</p>

<a name="pre"/><h6>Presente</h6>
<li>Opis prawd ogólnych, podawanie definicji lub informacji:</li>
<i>Dos y dos <b>suman</b> cuatro</i> - Dwa i dwa to cztery<br/>
<i>Yo <b>vivo</b> en Madrid</i> - Mieszkam w Madrycie<br/>
<li>Opis czynności wykonywanych zwyczajowo lub z pewną częstotliwością:</li>
<i>En mi casa <b>comemos</b> a las 3</i> - U mnie jemy obiad o 3<br/>
<i>Los sábados también <b>trabajo</b></i> - W soboty też pracuję<br/>
<li>Podawanie instrukcji:</li>
<i>Para hablar por teléfono, primero <b>levantas</b> el auricular, luego <b>metes</b> la moneda o la tarjeta</i> - Żeby porozmawiał przez telefon, najpierw podnosisz słuchawkę, a potem wrzucasz monetę lub wkładasz kartę
<li>Mówienie o przyszłości:</li>
<i>En junio <b>termino</b> el curso</i> - W czerwcu kończę rok akademicki
<table>
<tr><td>&nbsp;</td><td><u>entr<b>ar</b></u></td><td><u>com<b>er</b></u></td><td><u>viv<b>ir</b></u></td></tr>
<tr><td>(yo)</td><td>entr<b>-o</b></td><td>com<b>-o</b></td><td>viv<b>-o</b></td></tr>
<tr><td>(tú)</td><td>entr<b>-as</b></td><td>com<b>-es</b></td><td>viv<b>-es</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>entr<b>-a</b></td><td>com<b>-e</b></td><td>viv<b>-e</b></td></tr>
<tr><td>(nosotros/-as)</td><td>entr<b>-amos</b></td><td>com<b>-emos</b></td><td>viv<b>-imos</b></td></tr>
<tr><td>(vosotros/-as)</td><td>entr<b>-áis</b></td><td>com<b>-éis</b></td><td>viv<b>-ís</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td><td>entr<b>-an</b></td><td>com<b>-en</b></td><td>viv<b>-en</b></td></tr>
</table>

<a name="ppe"/><h6>Pretérito Perfecto</h6>
<li>Wyrażanie niedawnej przeszłości; używa się wtedy z takimi określeniami czasu jak <i>hoy</i> (dzisiaj), <i>esta mañana</i> (dzisiaj rano), <i>hace un rato</i> (przed chwilą):</li>
<i>Hoy no <b>he visto</b> a mi hermana</i> - Dzisiaj nie widziałem mojej siostry
<li>Wyrażanie przeszłości nieokreślonej, bez oznaczenia czasu; ważny jest rezultat czynności:</li>
<i><b>He perdido</b> el reloj, no sé dónde</i> - Zgubiłem zegarek, nie wiem gdzie
<li>Pytanie i informowanie o osobistych doświadczeniach, z określeniami typu <i>ya</i> (już), <i>todavía no</i> (jeszcze nie), <i>alguna vez</i> (kiedykolwiek), <i>nunca</i> (nigdy):</li>
<i><b>&iquest;Has estado</b> alguna vez en América del Sur?</i><br/>
<i>María <b>se ha casado</b> tres veces</i>
<table>
<tr><td>(yo)</td>				<td><b>he</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>has</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>ha</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>hemos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>habéis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>han</b></td></tr>
</table>

<a name="pin"/><h6>Pretérito Indefinido</h6>
<li>Wyrażanie czynności przeszłej i skończonej; może to być czynność powtarzająca się lub ciągła:</li>
<i>El año pasado <b>vi</b> muchas veces a tu hermano</i> - W zeszłym roku widziałem wiele razy twojego brata<br/>
<i>Isabel <b>vivió</b> en Alemania más de 20 años</i> - Isabel mieszkała w Niemczech ponad 20 lat
<li>Wyliczanie faktów biograficznych:</li>
<i>Victor <b>trabajó</b>, <b>se casó</b> y <b>vivió</b> en Sevilla</i> - Victor pracował, ożenił się i mieszkał w Sewilli
<li>Używa się z takimi określeniami czasu jak <i>ayer</i> (wczoraj), <i>la semana pasada</i> (w zeszłym tygodniu), <i>en abril</i> (w kwietniu), <i>en 1945</i>, <i>hace tres meses</i> (trzy miesiące temu):</li>
<i>La semana pasada <b>vi</b> a tu hermano en el teatro</i> - W zeszłym tygodniu widziałem twojego brata w teatrze
<table>
<tr><td>&nbsp;</td>           <td><u>bail<b>ar</b></u></td><td><b>-er/-ir</b> (<u>sal<b>ir</b></u>)</td></tr>
<tr><td colspan="4">&nbsp;</td></tr>
<tr><td>(yo)</td>			 <td>bail<b>-é</b></td><td>sal<b>-í</b></td></tr>
<tr><td>(tú)</td>      <td>bail<b>-aste</b></td><td>sal<b>-iste</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>bail<b>-ó</b></td><td>sal<b>-ió</b></td></tr>
<tr><td>(nosotros/-as)</td>   <td>bail<b>-amos</b></td><td>sal<b>-imos</b></td></tr>
<tr><td>(vosotros/-as)</td>   <td>bail<b>-asteis</b></td><td>sal<b>-isteis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td> <td>bail<b>-aron</b></td><td>sal<b>-ieron</b></td></tr>
</table>

<a name="fim"/><h6>Futuro Imperfecto</h6>
<li>Mówienie o czynnościach przyszłych przy użyciu następujących określeń czasu: <i>luego</i> (później), <i>el año próximo</i> (w przyszłym roku), <i>mañana</i> (jutro)</li>
A - <i>&iquest;Has hecho los deberes?</i> - Zrobiłeś zadania?<br/>
B - <i>No, los <b>haré</b> luego.</i> -  Nie, zrobię je później
<li>Wyrażanie przypuszczenia w teraźniejszości.</li>
<table>
<tr><td>&nbsp;</td>           <td><b>-ar/-er/-ir</b> (entrar)</td></tr>
<tr><td colspan="4">&nbsp;</td></tr>
<tr><td>(yo)</td>				<td>entrar<b>-é</b></td></tr>
<tr><td>(tú)</td>			<td>entrar<b>-ás</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>entrar<b>-á</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td>entrar<b>-emos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td>entrar<b>-éis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td>entrar<b>-án</b></td></tr>
</table>

<a name="pim"/><h6>Pretérito Imperfecto</h6>
<li>Wyraża czynności przeszłe i niedokończone, czynności zwyczajowe i powtarzające się w przeszłości:</li>
<i>Cuando <b>éramos</b> pequeños, todos los domingos <b>íbamos</b> al río</i> -  Kiedy byliśmy mali, w każdą niedzielę szliśmy nad rzekę<br/>
<i>Antes <b>fumaba</b> mucho</i> -  Kiedyś dużo paliłem
<li>Często wyraża przyczynę faktu z przeszłości lub opisuje jego okoliczności:</li>
<i>Ayer no vine a clase porque <b>estaba</b> enfermo</i> -  Wczoraj no przyszedłem na zajęcia, bo byłem chory<br/>
<i><b>Dormía</b> profundamente cuando sonó el telefono</i> -  Spałem głęboko, kiedy zadzwonił telefon
<li>Dokonywanie opisów w przeszłości:</li>
<i>La piscina de los Martínez <b>era</b> más grande que la nuestra</i> -  Basen Martinezów był większy niż nasz
<li>Przedstawianie czynności w trakcie jej trwania:</li>
<i>Mientras todos <b>charlaban</b>, Juan <b>miraba</b> por la ventana</i> -  Podczas gdy wszyscy rozmawiali, Juan wyglądał przez okno
<table>
<tr><td>&nbsp;</td>           <td><u>bail<b>ar</b></u></td><td><b>-er/-ir</b> (<u>com<b>er</b></u>)</td></tr>
<tr><td colspan="4">&nbsp;</td></tr>
<tr><td>(yo)</td>			 <td>bail<b>-aba</b></td><td>com<b>-ía</b></td></tr>
<tr><td>(tú)</td>      <td>bail<b>-abas</b></td><td>com<b>-ías</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>bail<b>-aba</b></td><td>com<b>-ía</b></td></tr>
<tr><td>(nosotros/-as)</td>   <td>bail<b>-ábamos</b></td><td>com<b>-íamos</b></td></tr>
<tr><td>(vosotros/-as)</td>   <td>bail<b>-abais</b></td><td>com<b>-íais</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td> <td>bail<b>-aban</b></td><td>com<b>-ían</b></td></tr>
</table>

<a name="ppl"/><h6>Pretérito Pluscuamperfecto</h6>
<li>Wyraża czynności przeszłe poprzedzające inne:</li>
<i>Cuando volví a casa, Tere ya <b>había hecho</b> la comida</i> -  Kiedy wróciłem do domu, Tere już zrobiła obiad
<li>Używa się przy określeniu <i>nunca antes</i> (nigdy przedtem).</li>
<table>
<tr><td>(yo)</td>				<td><b>había</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>habías</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>había</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>habíamos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>habíais</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>habían</b></td></tr>
</table>

<a name="fpe"/><h6>Futuro Perfecto</h6>
<li>Używa się przy mówieniu o czynności przyszłej, która będzie skończona:</li>
<i>Dentro de tres meses ya <b>habrán acabado</b> las obras de acera</i> -  Za trzy miesiące skończą już remont chodnika
<li>Wyrażanie przypuszczenia w przeszłości.</li>
<table>
<tr><td>(yo)</td>				<td><b>habré</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>habrás</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>habrá</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>habremos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>habréis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>habrán</b></td></tr>
</table>
    </SGrammarIndicativo>
    )
};

export default GrammarIndicativo;